// extracted by mini-css-extract-plugin
export var cardLayout = "_8k-1";
export var paginationContainer = "_8k-0";